import Button from "@material-ui/core/Button";
import Container from "@material-ui/core/Container";
import { makeStyles } from "@material-ui/core/styles";
import AddIcon from "@material-ui/icons/Add";
import MaterialTable from "material-table";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import {
  addSupplierAction,
  deleteSupplierAction,
  editSupplierAction,
  getSuppliersAction,
} from "../../../../../store/supplier/actions";
import { getSessionData } from "../../../base/helper/baseHelper";
import Base from "../../../base/views/base";
import ConfirmationDialog from "../../../base/views/ConfirmationDialog";
import Popup from "../../../base/views/Popup";
import LandingPageFooter from "../../../LandingPage/views/LandingPageFooter";
import SupplierForm from "./SupplierForm";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    "& .MuiPaper-root": {
      backgroundColor: "rgba(255,255,255,0.5)",
      backdropFilter: "blur(6px)",
      borderRadius: "15px",
      padding: "10px",
      marginTop: "1%",
      justifyContent: "center",
      alignItems: "center",
    },
  },

  pricingheader: {
    marginTop: theme.spacing(2),
  },
  card: {
    height: 400,
    width: "100%",
    maxWidth: 195,
    position: "relative",
    borderRadius: 16,
    display: "flex",
    backgroundColor: "rgba(255,255,255,0.5)",
    backdropFilter: "blur(6px)",
    flexDirection: "column",
    paddingTop: 4,
    paddingBottom: 4,
    "&:last-child": {
      paddingRight: 5,
    },
    flexShrink: 0,
    marginRight: theme.spacing(5),
  },
  cardPricing: {
    display: "flex",
    justifyContent: "center",
    alignItems: "baseline",
    marginBottom: theme.spacing(2),
  },
  cardHeader: {
    fontSize: "small",
  },
  cardpaidlist: {
    paddingTop: 5,
    justifyContent: "center",
    paddingLeft: 10,
  },
  cardpaid: {
    paddingTop: 2,
    paddingLeft: 2,
    fontSize: "small",
    justifyContent: "center",
  },
  planswitcher: {
    paddingBottom: 12,
    paddingTop: 4,
  },
  showallplan: {
    paddingBottom: 12,
    paddingTop: 10,
    justifyContent: "center",
    display: "flex",
  },
  cardpaidlisticon: {
    position: "relative",
    top: 8,
  },
  gridlisticon: {
    position: "relative",
    left: 25,
  },
  appBar: {
    backgroundColor: "rgba(255,255,255,0.5)",
  },
  title: {
    flexGrow: 1,
    color: "rgba(0, 0, 0, 0.7);",
  },
  plantable: {
    backgroundColor: "rgba(255,255,255,0.5)",
    backdropFilter: "blur(6px)",
    marginBottom: "1%",
  },
  plantable2: {
    backgroundColor: "rgba(255,255,255,0.5)",
    backdropFilter: "blur(6px)",
    marginBottom: "1%",
  },
  plantableheader: {
    alignItems: "center",
    display: "inline-flex",
    flexWrap: "Wrap",
    justifyContent: "left",
  },
  container: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    marginBottom: theme.spacing(2),
    borderRadius: "5px",
    backgroundColor: "rgba(255,255,255,0.5)",
    backdropFilter: "blur(8px)",
  },
}));

function SupplierLandingPage(props) {
  const classes = useStyles();
  const [recordForEdit, setRecordForEdit] = useState(null);
  const [openPopup, setOpenPopup] = useState(false);
  const [storeId, setStoreId] = useState("");
  const [moduleAccess, setModuleAccess] = useState({});
  const [openDialog, setOpenDialog] = useState(false);
  const [deleteSupplierObj, setDeleteSupplierObj] = useState([]);

  const {
    suppliers,
    getSuppliers,
    addSupplier,
    editSupplier,
    deleteSupplier,
  } = props;

  useEffect(() => {
    const store = JSON.parse(getSessionData({ key: "store" }));
    setStoreId(store.storeid);
    if (storeId) {
      const userModules = JSON.parse(getSessionData({ key: "userModules" }));
      const supplierModule = userModules.find(
        (module) => module.modulename === "Supplier Management"
      );
      setModuleAccess(supplierModule);
      getSuppliers(storeId);
    }
  }, [storeId, getSuppliers]);

  const addOrEdit = (resetForm) => {
    resetForm();
    setRecordForEdit(null);
    setOpenPopup(false);
  };

  const openInPopup = (item) => {
    setRecordForEdit({
      ...item,
      supplier_name:
        item.supplier_name !== null || item.supplier_name !== ""
          ? item.supplier_name
          : "",
      supplierEdiCode:
        item.suppliercode !== null || item.suppliercode !== ""
          ? item.suppliercode
          : "",
    });
    setOpenPopup(true);
  };

  const onDeleteButtonClick = (e, rowData) => {
    setDeleteSupplierObj({
      store_id: storeId,
      supplier_id: rowData.supplier_id,
    });
    setOpenDialog(true);
  };

  const handleDelete = () => {
    setOpenDialog(false);
    deleteSupplier(deleteSupplierObj);
    setDeleteSupplierObj([]);
  };

  return (
    <div style={{ display: "flex" }}>
      <Base showBaseMenu={true}>
        {/* <h1 style={{ marginTop: "4%" }}>Supplier Management</h1> */}
        <Container
          maxWidth="xl"
          className={classes.container}
          style={{ marginTop: "4%" }}
        >
          <Button
            startIcon={<AddIcon />}
            onClick={() => {
              setOpenPopup(true);
              setRecordForEdit(null);
            }}
            {...{ disabled: moduleAccess.createaccess === "Y" ? false : true }}
            color="primary"
            style={{
              backgroundColor: "rgb(22, 177, 255)",
              color:"white",
              borderRadius: "0.5rem",
            }}
          >
            Add New
          </Button>
        </Container>
        <div className={classes.root}>
          <MaterialTable
            title="Supplier List"
            columns={[
              {
                title: "Supplier Name",
                field: "supplier_name",
                defaultSort: "asc",
                cellStyle: { width: "35%" },
              },
              { title: "Alias Name", field: "aliasname" },
              { title: "Account No.", field: "accountno" },
              { title: "Contact No.", field: "contactno" },
              { title: "Email", field: "contactmail" },
              { title: "EDI setup", field: "eda_setup" },
            ]}
            data={suppliers}
            actions={[
              {
                icon: "edit",
                tooltip: "Edit",
                onClick: (_event, rowData) => openInPopup(rowData),
                disabled: moduleAccess.editaccess === "Y" ? false : true,
              },
              {
                icon: "delete",
                tooltip: "Delete",
                onClick: (_event, rowData) => {
                  onDeleteButtonClick(_event, rowData);
                },
                disabled: moduleAccess.deleteaccess === "Y" ? false : true,
              },
            ]}
            options={{
              maxBodyHeight: 670,
              paging: true,
              pageSize: 25,
              pageSizeOptions: [25, 50, 100],
              headerStyle: {
                backgroundColor: "rgba(255,255,255,1)",
                color: "black",
              },
            }}
          />
        </div>
        <LandingPageFooter />
        <Popup
          title="Supplier Form"
          openPopup={openPopup}
          setOpenPopup={setOpenPopup}
        >
          <SupplierForm
            recordForEdit={recordForEdit}
            addSupplier={addSupplier}
            editSupplier={editSupplier}
            addOrEdit={addOrEdit}
            storeid={storeId}
          />
        </Popup>
        <ConfirmationDialog
          title="Do you want to proceed?"
          openDialog={openDialog}
          closeDialog={setOpenDialog}
          popupTitle="Stores"
          onSubmit={handleDelete}
        />
      </Base>
    </div>
  );
}

const mapStateToDispatch = (state) => ({
  suppliers: state.supplier,
});

const mapDispatchToProps = (dispatch) => {
  return {
    addSupplier: (supplier) => dispatch(addSupplierAction(supplier)),
    editSupplier: (supplier) => dispatch(editSupplierAction(supplier)),
    deleteSupplier: (supplier) => dispatch(deleteSupplierAction(supplier)),
    getSuppliers: (storeId) => dispatch(getSuppliersAction(storeId)),
  };
};

export default connect(
  mapStateToDispatch,
  mapDispatchToProps
)(SupplierLandingPage);
